import Engage_Overview from '@/components/Engage/Engage_Overview.vue';
import { FEATURES } from '@/constants/features';
import { ENGAGE_TABS } from '@/components/Engage/engage_tabs';

const BASE_META = { requiresAuth: true, layout: 'default' };

export const ENGAGE_ROUTES = [
  { path: '/engage', redirect: '/engage/partners', meta: { ...BASE_META, canAccess: FEATURES.MODULE_ENGAGE } },
  ...ENGAGE_TABS.map((tab) => ({
    path: tab.path,
    name: tab.name,
    component: Engage_Overview,
    props: { activeTab: tab.key },
    meta: { ...BASE_META, ...tab.meta },
  })),
  { path: '/transform', redirect: '/engage/transform' },
  { path: '/manage', redirect: '/engage/projects' },
  { path: '/team', redirect: '/engage' },
];
